export default "__VITE_ASSET__CanhkS5J__"